import parseJSONSafe from '../../../../scripts/utils/parse-json-safe.js';

export const isLegacyFormat = (data) => !data?.sap_model_version;

const createScreenObject = (stepData, fileName) => ({
  fileUrl: stepData?.step_file_url || '',
  fileType: stepData?.step_file_type || '',
  fileId: stepData?.step_file_id || '',
  fileName: fileName || '',
  fileAltText: stepData?.step_file_alt_text || '',
});

export const transformOverviewScreenshot = (overviewSteps, title) => ({
  screen: createScreenObject(overviewSteps, title),
});

export const transformStep = (step) => ({
  title: step?.step_title || '',
  description: step?.step_description || '',
  screen: createScreenObject(step, step?.step_title),
});

export const transformSection = (section) => {
  const steps = Array.isArray(section?.section_steps)
    ? section.section_steps
    : [];

  const sortedSteps = [...steps].sort((a, b) => {
    const orderA = a?.hero_step_order ?? 0;
    const orderB = b?.hero_step_order ?? 0;
    return orderA - orderB;
  });

  return {
    section_title: section?.section_title || '',
    step: sortedSteps.map(transformStep),
  };
};

export const transformSections = (sections) => {
  if (!Array.isArray(sections)) {
    return [];
  }

  const sortedSections = [...sections].sort((a, b) => {
    const orderA = a?.section_order ?? 0;
    const orderB = b?.section_order ?? 0;
    return orderA - orderB;
  });

  return sortedSections.map(transformSection);
};

export const transformToLegacyFormat = (newData) => {
  if (isLegacyFormat(newData)) {
    return newData;
  }

  const title = newData.title || '';

  return {
    title,
    overview_text: newData.overview_text || '',
    overview_screenshot: transformOverviewScreenshot(
      newData.overview_steps,
      title,
    ),
    section: transformSections(newData.section),
    product_tour_version: newData.product_tour_version || '',
    call_to_action_title: newData.call_to_action_title || '',
    call_to_action: newData.call_to_action || {},
    uuid: newData.uuid || '',
    sap_model_version: newData.sap_model_version || '',
  };
};

export const parseAndTransformFragmentContent = (fragmentData) => {
  const rawData = parseJSONSafe(fragmentData.items[0].fields.content, {});
  return transformToLegacyFormat(rawData);
};

export const createCompatibleFragmentItem = (
  originalFragmentItem,
  transformedData,
) => ({
  ...originalFragmentItem,
  fields: {
    ...originalFragmentItem.fields,
    content: JSON.stringify(transformedData),
  },
});

export const createTransformedFragmentData = (
  originalFragmentData,
  compatibleFragmentItem,
) => ({
  ...originalFragmentData,
  items: [compatibleFragmentItem],
});

export const processFragmentData = (fragmentData) => {
  const transformedData = parseAndTransformFragmentContent(fragmentData);
  const compatibleFragmentItem = createCompatibleFragmentItem(
    fragmentData.items[0],
    transformedData,
  );
  const transformedFragmentData = createTransformedFragmentData(
    fragmentData,
    compatibleFragmentItem,
  );

  return {
    compatibleFragmentItem,
    transformedFragmentData,
  };
};
